import styled, { css } from 'styled-components'

import { BASE_RADIO_HEIGHT } from '@/lib/core/components/Radio/Radio.styles'

export const MARK_OFFSET = '3px'

type StyledRadiomarkProps = {
  isActive: boolean
}

export const StyledRadiomark = styled.span<StyledRadiomarkProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: ${BASE_RADIO_HEIGHT};
  height: ${BASE_RADIO_HEIGHT};
  border: ${({ theme: { borderBase } }) => borderBase};
  border-radius: 50%;
  background: #fff;

  &::after {
    content: '';
    position: absolute;
    top: ${MARK_OFFSET};
    left: ${MARK_OFFSET};
    display: none;
    width: calc(
      ${BASE_RADIO_HEIGHT} - ${({ theme: { border } }) => border.width} * 2 - ${MARK_OFFSET} * 2
    );
    height: calc(
      ${BASE_RADIO_HEIGHT} - ${({ theme: { border } }) => border.width} * 2 - ${MARK_OFFSET} * 2
    );
    border-radius: 50%;
    background-color: ${({ theme: { colors } }) => colors.active};
    ${({ isActive }) =>
      isActive &&
      css`
        display: block;
      `}
  }
`
